<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/corretor/oportunidades"
              >Oportunidades</router-link
            >
          </li>
          <li class="breadcrumb-item active">Detalhes da Oportunidade</li>
        </ol>

        <!-- Dados usuário-->
        <div class="delete-item">
          <h4 @click="deletarOportunidade">Deletar oportunidade</h4>
        </div>
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-info"></i>Dados do contratante</h2>
          </div>
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label>Nome</label>
                <input
                  v-model="assinante.name"
                  class="form-control"
                  placeholder="Nome"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Sobrenome</label>
                <input
                  v-model="assinante.last_name"
                  class="form-control"
                  placeholder="Sobrenome"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Telefone</label>
                <input
                  class="form-control"
                  v-mask="'(##) 9####-####'"
                  type="tel"
                  v-model="assinante.telefone"
                  @blur="
                    (e) => {
                      if (e.target.value.split(' ')[1]) {
                        assinante.phones.number = e.target.value
                          .split(' ')[1]
                          .replace('-', '');
                        assinante.phones.area_code = e.target.value
                          .split(' ')[0]
                          .replace(/[^0-9]/g, '');
                      } else if (e.target.value === '') {
                        assinante.phones.number = '';
                        assinante.phones.area_code = '';
                      }
                    }
                  "
                  placeholder="Telefone"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CPF</label>
                <input
                  class="form-control"
                  type="tel"
                  v-mask="'###.###.###-##'"
                  placeholder="CPF"
                  v-model="assinante.cpf"
                  @blur="
                    (e) =>
                      (assinante.cpf = e.target.value.replace(/[^0-9]/g, ''))
                  "
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>E-mail</label>
                <input
                  v-model="assinante.email"
                  class="form-control"
                  placeholder="E-mail"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Senha</label>
                <input
                  class="form-control"
                  type="password"
                  placeholder="Senha"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>CEP</label>
                <input
                  class="form-control"
                  v-mask="'#####-###'"
                  v-model="assinante.zip_code"
                  type="tel"
                  @blur="(e) => getAddress(e.target.value)"
                  placeholder="CEP"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Cidade</label>
                <input
                  class="form-control"
                  v-model="assinante.city"
                  readonly
                  placeholder="Cidade"
                />
              </div>
            </div>
            <div class="col-md-1">
              <div class="form-group">
                <label>Estado</label>
                <input
                  class="form-control"
                  v-model="assinante.state"
                  readonly
                  placeholder="Estado"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  class="form-control"
                  v-model="assinante.district"
                  placeholder="Bairro"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Rua</label>
                <input
                  class="form-control"
                  v-model="assinante.street"
                  placeholder="Rua"
                />
              </div>
            </div>
            <div class="col-md-1">
              <div class="form-group">
                <label>Número</label>
                <input
                  class="form-control"
                  type="number"
                  placeholder="N.º"
                  v-model="assinante.street_number"
                />
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label>Complemento</label>
                <input
                  class="form-control"
                  v-model="assinante.complement"
                  placeholder="Complemento"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p>
                <button
                  href="#0"
                  class="btn_1 medium pull-right btn-color flex align-items-center justify-content-center"
                  @click="editUser"
                >
                  Salvar <i class="fa fa-check ml-3"></i>
                </button>
              </p>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-users"></i>Participantes</h2>
          </div>

          <template v-for="(participante, index) in participantes">
            <div :key="index">
              <p class="flex justify-content-between cursor-pointer">
                <b class="badge-item">Participante {{ index + 1 }} </b>
                <i
                  @click="() => deletarParticipante(index)"
                  class="fa fa-times badge-item"
                ></i>
              </p>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Nome</label>
                    <input
                      v-model="participantes[index].name"
                      class="form-control"
                      placeholder="Nome"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Data de nascimento</label>
                    <input
                      class="form-control"
                      v-mask="'##/##/####'"
                      placeholder="Nascimento"
                      v-model="participantes[index].birth_date"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>RG (Não obrigatório)</label>
                    <input
                      v-model="participantes[index].rg"
                      class="form-control"
                      type="tel"
                      placeholder="RG"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>CPF</label>
                    <input
                      class="form-control"
                      type="tel"
                      v-mask="'###.###.###-##'"
                      v-model="participantes[index].cpf"
                      @blur="
                        (e) =>
                          (participantes[index].cpf = e.target.value.replace(
                            /[^0-9]/g,
                            ''
                          ))
                      "
                      placeholder="CPF"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>CNS (Não obrigatório)</label>
                    <input
                      class="form-control"
                      placeholder="CNS"
                      v-model="participantes[index].cns"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>E-mail</label>
                    <input
                      class="form-control"
                      type="email"
                      v-model="participantes[index].email"
                      placeholder="E-mail"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Naturalidade (Não obrigatório)</label>
                    <input
                      class="form-control"
                      v-model="participantes[index].naturalidade"
                      placeholder="Ex: Poços de Caldas"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Planos</label>
                    <select 
                      id="plans" 
                      class="form-control"
                      v-model="participantes[index].plan_id"
                      :disabled="!!participantes[index].plano_base"
                      @change="onPlanoChange(index)"
                    >
                      <option value="0" selected hidden disabled>Escolha um plano</option>
                      <template v-for="plano in planosEscolher">
                        <option :key="plano.id" :id="plano.id" :value="`${plano.id}`">
                          {{`${plano.id} - ${plano.name}${Number(plano.tipo_plano) === 2 ? ' (Plano familiar)' : ''}`}}
                        </option>
                      </template>
                    </select>
                    <small v-if="participantes[index].plano_base" class="text-muted">
                      Parte do plano familiar {{ nomePlanoFamiliar(participantes[index].plano_base) }}
                    </small>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Nome da mãe</label>
                    <input
                      class="form-control"
                      placeholder="Nome da mãe"
                      v-model="participantes[index].nome_mae"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Estado Civil</label>
                    <select class="form-control" v-model="participantes[index].estado_civil">
                      <option value="" selected disabled>Selecione o estado civil</option>
                      <option value="Amasiado">Amasiado</option>
                      <option value="Casado">Casado</option>
                      <option value="Convivente">Convivente</option>
                      <option value="Desquitado">Desquitado</option>
                      <option value="Divorciado">Divorciado</option>
                      <option value="Separado">Separado</option>
                      <option value="Solteiro">Solteiro</option>
                      <option value="Viúvo">Viúvo</option>
                      <option value="Outros">Outros</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Gênero</label>
                    <select class="form-control" v-model="participantes[index].genero">
                      <option value="" selected disabled>Selecione o gênero</option>
                      <option value="Feminino">Feminino</option>
                      <option value="Masculino">Masculino</option>
                      <option value="Outros">Outros</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label>Parentesco</label>
                    <select
                      v-model="participantes[index].parentesco"
                      class="form-control"
                    >
                      <option value="" disabled selected>Selecione o parentesco</option>
                      <option value="Nenhum, sou responsável financeiro">
                        Nenhum, sou responsável financeiro
                      </option>
                      <option value="Cônjuge">Cônjuge</option>
                      <option
                        value="Convivente, sem eventual concorrência com o cônjuge, salvo por decisão judicial"
                      >
                        Convivente, sem eventual concorrência com o cônjuge,
                        salvo por decisão judicial
                      </option>
                      <option
                        value="Filhos solteiro, até 21 anos incompletos, ou até 24 anos incompletos, desde que cursando graduação em nível superior de ensino"
                      >
                      Filhos solteiro, até 21 anos incompletos, ou até 24 anos incompletos, desde que cursando graduação em nível superior de ensino
                      </option>
                      <option
                        value="Enteado, o menor sob a guarda por força de decisão judicial e o menor tutelado, que ficam equiparados aos filhos"
                      >
                        Enteado, o menor sob a guarda por força de decisão
                        judicial e o menor tutelado, que ficam equiparados aos
                        filhos
                      </option>
                      <option
                        value="Neto(a)/bisneto(a)"
                      >
                      Neto(a)/bisneto(a)
                      </option>
                      <option value="Irmão(ã)">
                        Irmão(ã)
                      </option>
                      <option value="Pais, avós e bisavós">
                        Pais, avós e bisavós
                      </option>
                      <option value="Tio(a)">
                        Tio(a)
                      </option>
                      <option value="Sogro(a)">
                        Sogro(a)
                      </option>
                      <option value="Genro/nora">
                        Genro/nora
                      </option>
                      <option value="Cunhado(a)">
                        Cunhado(a)
                      </option>
                      <option value="Padrasto/madrasta">
                        Padrasto/madrasta
                      </option>
                      <option value="Sobrinho(a)">
                        Sobrinho(a)
                      </option>
                      <!-- <option value="Pais">Pais</option>
                      <option value="Sogros">Sogros</option> -->
                    </select>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </template>

          <div class="row">
            <div class="btnContainer col-md-12 flex align-items-center justify-content-between mt-5">
        
              <button
                href="#0"
                class="btnCustom btn_1 medium col-md-4 btn-color flex align-items-center justify-content-center"
                @click="addParticipante"
              >
                Adicionar participante <i class="fa fa-plus ml-3"></i>
              </button>

              <button
                href="#0"
                class="btnCustom btn_1 medium col-md-2 btn-color-blue flex align-items-center justify-content-center"
                @click="saveDependents"
              >
                Salvar <i class="fa fa-check ml-3"></i>
              </button>
              
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-usd"></i>Dados de pagamento</h2>
          </div>
          <div class="flex flex-wrap align-items-start justify-content-between">
            <div class="col-md-6">
              <div class="row">
               <div class="col-md-12">
                  <div class="form-group">
                    <label>CPF do portador</label>
                    <input
                      class="form-control"
                      type="tel"
                      v-mask="'###.###.###-##'"
                      placeholder="CPF"
                      v-model="checkout.billing_info.credit_card.cpf"
                      @blur="
                        (e) =>
                          (checkout.billing_info.credit_card.cpf = e.target.value.replace(/[^0-9]/g, ''))
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Número do cartão de crédito</label>
                    <input
                      class="form-control"
                      v-model="checkout.billing_info.credit_card.number"
                      v-mask="'#### #### #### ####'"
                      @change="(e) => checkout.billing_info.credit_card.number =  e.target.value.replace(' ', '')"
                      type="text"
                      placeholder="Número"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Nome presente no cartão de crédito</label>
                    <input
                      v-model="checkout.billing_info.credit_card.holder_name"
                      class="form-control"
                      placeholder="Nome"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>CVV</label>
                    <input
                      class="form-control"
                      v-mask="'###'"
                      v-model="checkout.billing_info.credit_card.cvv"
                      type="text"
                      placeholder="CVV"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Validade</label>
                    <input
                      class="form-control"
                      type="tel"
                      v-mask="'##/##'"
                      @blur="
                        (e) => {
                          if (e.target.value.split('/')[0]) {
                            checkout.billing_info.credit_card.expiration_month = e.target.value.split(
                              '/'
                            )[0];
                            checkout.billing_info.credit_card.expiration_year = e.target.value.split(
                              '/'
                            )[1];
                          }
                        }
                      "
                      placeholder="MM/AA"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>Cupom de desconto</label>
                  <input
                    type="text"
                    v-model="cupom"
                    @blur="validaCupom"
                    class="form-control text-uppercase"
                    :class="cupom_class"
                  />
                  <div v-if="tem_cupom" class="mt-2">
                    <span
                        class="msg-erro"
                        v-if="!cupom_valido"
                      >*Cupom inválido
                    </span>

                    <span
                        class="msg-success"
                        v-else
                      >{{`*Cupom aplicado, a primeira mensalidade será no valor de R$ ${valor_cupom}`}}
                      </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-5">
              <ShoppingCarDetails :shoppingCar="shoppingCar" :cotacao="cotacao"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <p>
              <button
                href="#0"
                class="btn_1 mb-5 medium pull-right btn-color flex align-items-center justify-content-center"
                @click="handleCheckout"
              >
                Finalizar <i class="fa fa-check ml-3"></i>
              </button>
            </p>
          </div>
        </div>
      </div>
      <b-modal
        id="modalTitular"
        title="Adicionar Titular"
        centered
        hide-footer
      >
        <div class="modalTitular">
          <h2 class="maze">Complete os dados do responsável</h2>
          <p
            class="maze mb-3"
          >Verificamos que os dependentes são menores de idade. Com isso precisamos de mais algumas informações do responsável.<br>
          Complete-as abaixo:</p>
          <form>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">Nome</label>
                  <input 
                    type="text" id="email" 
                    v-model="titular.name" 
                    class="form-control" 
                    placeholder="Nome"
                  />
                </div>
              </div>  
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">E-mail</label>
                  <input
                    type="text"
                    id="email"
                    v-model="titular.email"
                    class="form-control"
                    placeholder="E-mail"
                  />
                </div>
              </div>  
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="email">CPF</label>
                  <input
                    type="text"
                    id="email"
                    v-model="titular.cpf"
                    class="form-control"
                    v-mask="'###.###.###-##'"
                    placeholder="CPF"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="email">Aniversário</label>
                  <input
                    type="text"
                    id="email"
                    v-mask="'##/##/####'"
                    v-model="titular.birth_date"
                    class="form-control"
                    placeholder="Nascimento"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="email">RG</label>
                  <input 
                    type="text" 
                    id="email" 
                    v-model="titular.rg" 
                    class="form-control"
                    v-mask="'##################'"
                    placeholder="RG"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">Nome da Mãe</label>
                  <input
                    type="text"
                    id="email"
                    v-model="titular.nome_mae"
                    class="form-control"
                    placeholder="Nome da mãe"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Parentesco com os dependentes</label>
                  <select
                    v-model="titular.parentesco"
                    class="form-control"
                  >
                    <option value="" selected disabled>Selecione o grau de parentesco</option>
                    <option value="Pai">Pai</option>
                    <option value="Mae">Mãe</option>
                    <option value="Nenhum, sou tutelar do(s) dependente(s)">Nenhum, sou tutelar do(s) dependente(s)</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Estado Civil</label>
                  <select
                    v-model="titular.estado_civil"
                    class="form-control"
                  >
                    <option value="" selected disabled>Selecione o estado civil</option>
                    <option value="Amasiado">Amasiado</option>
                    <option value="Casado">Casado</option>
                    <option value="Convivente">Convivente</option>
                    <option value="Desquitado">Desquitado</option>
                    <option value="Divorciado">Divorciado</option>
                    <option value="Separado">Separado</option>
                    <option value="Solteiro">Solteiro</option>
                    <option value="Viúvo">Viúvo</option>
                    <option value="Outros">Outros</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Gênero</label>
                  <select
                    v-model="titular.genero"
                    class="form-control"
                  >
                    <option value="" selected disabled>Selecione o gênero</option>
                    <option value="Feminino">Feminino</option>
                    <option value="Masculino">Masculino</option>
                    <option value="Outros">Outros</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="btn-cadastro">
              <button type="button" @click="validaTitular" class="btn_1 mb-5 mt-2 medium pull-right btn-color flex align-items-center justify-content-center">
                Efetivar Cadastro
              </button>
            </div>
          </form>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  padronizaData,
  padronizaDataUS,
  tratamento_requisicao,
  alerta
} from "@/utils/util";
import { numberToCpf, toDate } from "@/utils/formater";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import { cpf } from 'cpf-cnpj-validator';
import { validate } from 'email-validator';
import { isName, isEmpty, isBirthday, isExpDate, isEmail } from "@/utils/validate";
import ShoppingCarDetails from '../../../components/ShoppingCarDetails.vue';

export default {
  components: { ShoppingCarDetails },
  mixins: [funcoesGerais],
  data() {
    return {
      isLoading: false,
      planos: [],
      planosEscolher: [],
      abrangencia: [],
      assinante: {},
      participantes: [],
      checkout: {
        cupom: null,
        billing_info: {
          credit_card: {
            holder_name: "",
            cpf: "",
            number: "",
            bandeira: "",
            cvv: "",
            expiration_month: "",
            expiration_year: "",
          },
        },
      },
      cupom: '',
      tem_cupom: false,
      cupom_valido: false,
      valor_cupom: null,
      cupom_class: '',
      titular: {
        name: "",
        birth_date: "",
        cpf: "",
        rg: "",
        email: "",
        parentesco: "",
        nome_mae: "",
        genero: "",
        estado_civil: ""
      },
      shoppingCar: {
        plans: [],
        total: 0,
        subtotal: 0,
        adesao: 0
      },
      plansList: [],
      plansCorretorId: [],
      qtdParticipantes: 0,
      cotacao: null,
      cotacaoTimer: null,
      carrinho: {
        plans: []
      }
    };
  },
  computed: {
  
    getCardType() {
      let number = this.checkout.billing_info.credit_card.number;
      let re = new RegExp("^4");
      if (number.match(re) != null) return "visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "mastercard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "discover";

      return "visa"; // default type
    },
  },
  mounted() {
    this.isLoading = true;
    const token = localStorage.getItem("token_adm_comprodonto")
      ? JSON.parse(localStorage.getItem("token_adm_comprodonto")).token
      : null;
    axios.all([
      axios.get(`plans_corretor/${this.parseJwt(token).usr.id}`),
      axios.get(`oportunidades_detalhes/${this.$route.params.id}`)
    ]).then(axios.spread((planosRes,res) => {
        let assinante = {
          ...res.data.assinante,
          ...res.data.usuario,
          ...{ telefone: res.data.telefone.area_code + res.data.telefone.number },
        };

        this.planosEscolher = planosRes.data;
        let planoId = this.planosEscolher[0].id;
        
        this.planos = res.data.planos;
        this.assinante = assinante;

        if (res.data.titulares) {
          this.titular = {
            name: res.data.titulares.name,
            cpf: numberToCpf(res.data.titulares.cpf),
            email: res.data.titulares.email,
            birth_date: toDate(res.data.titulares.birth_date),
            rg: res.data.titulares.rg,
            nome_mae: res.data.titulares.nome_mae,
            parentesco: res.data.titulares.parentesco,
            estado_civil: res.data.titulares.estado_civil,
            genero: res.data.titulares.genero,
            cns: res.data.titulares.cns,
            id: res.data.titulares.id,
            nome_pai: res.data.titulares.nome_pai,
            subscribers_id: res.data.titulares.subscribers_id,
          }
        }

        this.qtdParticipantes = res.data.dependentes.length;
        if (this.qtdParticipantes > 0) {
          this.participantes = res.data.dependentes;
          this.participantes.map((part) => {
            part.birth_date = padronizaData(part.birth_date);
            this.plansList.push(part.plan_id);
          });
          this.plansCorretorId = this.planosEscolher.map(plan => {return plan.id});
          this.plansCorretorId.map( planCorretorId => {
            const qtd = this.plansList.filter(id => id === planCorretorId).length;
            if (qtd > 0) {
              axios
                .get(`detalhes/plano/${planCorretorId}`)
                .then((res) => res.data)
                .then((response) => {
                  this.shoppingCar.plans.push({...response.plano, qtd});
                  this.updateTotal_Subtotal_Adesao();
                  this.abrangencia = response.abrangencia;
                })
                .catch((err) => {
                  this.isLoading = false;
                  this.$swal.fire({
                    position: "center",
                    type: "error",
                    title: "Erro",
                    text: "Erro ao buscar os detalhes dos planos.",
                    showConfirmButton: true,
                  })
                });
            }
          })
        } else {
          axios
            .get(`detalhes/plano/${planoId}`)
            .then((res) => res.data)
            .then((response) => {
              this.abrangencia = response.abrangencia;
            })
            .catch((err) => {
              this.isLoading = false;
              this.$swal.fire({
                position: "center",
                type: "error",
                title: "Erro",
                text: "Erro ao buscar a abrangência dos planos.",
                showConfirmButton: true,
              })
            });

          let particip = {
            plan_id: this.planosEscolher[0].id,
            plano_base: null,
            name: "",
            birth_date: "",
            cpf: "",
            rg: "",
            email: "",
            parentesco: "",
            nome_mae: "",
            estado_civil: "",
            genero: "",
            cns: "",
            naturalidade: "",
          }
          this.participantes[0] = particip;
        }
        this.isLoading = false;
      }))
      .catch((err) => {
        this.isLoading = false;
         this.$swal.fire({
            position: "center",
            type: "error",
            title: "Erro ao buscar oportunidade",
            text: err.message,
            showConfirmButton: true,
          })
      });
  },
  methods: {
    nomePlanoFamiliar(id) {
      const plano = this.planosEscolher.find((p) => String(p.id) === String(id));
      return plano ? plano.name : `#${id}`;
    },

    // Valores com desconto do plano e do plano familiar, calculados pelo servidor (mesmo cálculo da cobrança)
    atualizaCotacao() {
      const participantes = this.participantes
        .filter((part) => part.plan_id && String(part.plan_id) !== "0")
        .map((part) => ({
          plan_id: parseInt(part.plan_id),
          plano_base: part.plano_base ? parseInt(part.plano_base) : null,
        }));

      if (participantes.length === 0) {
        this.cotacao = null;
        return;
      }

      axios
        .post("cotacao_corretor", { participantes })
        .then((res) => {
          this.cotacao = res.data;
        })
        .catch(() => {
          // sem cotação o carrinho volta a exibir o cálculo local
          this.cotacao = null;
        });
    },

    // Ao escolher um plano familiar, cria os participantes dos planos vinculados (qtd_min de cada um)
    async onPlanoChange(index) {
      const participante = this.participantes[index];
      const plano = this.planosEscolher.find((p) => String(p.id) === String(participante.plan_id));

      if (!plano || Number(plano.tipo_plano) !== 2) {
        participante.plano_base = null;
        return;
      }

      this.isLoading = true;
      try {
        const vinculados = (await axios.get(`planos_vinculados/${plano.id}`)).data;

        const planosDaFamilia = [];
        vinculados.forEach((v) => {
          const qtd = Math.max(parseInt(v.qtd_min) || 1, 1);
          for (let i = 0; i < qtd; i++) planosDaFamilia.push(String(v.plans_id));
        });

        if (planosDaFamilia.length === 0) {
          participante.plan_id = "";
          this.$swal.fire({
            position: "center",
            type: "warning",
            title: "Aviso",
            text: "Este plano familiar não possui planos vinculados.",
            showConfirmButton: true,
          });
          return;
        }

        participante.plan_id = planosDaFamilia[0];
        participante.plano_base = plano.id;

        const novos = planosDaFamilia.slice(1).map((planId) => ({
          plan_id: planId,
          plano_base: plano.id,
          name: "",
          birth_date: "",
          cpf: "",
          rg: "",
          email: "",
          parentesco: "",
          nome_mae: "",
          estado_civil: "",
          genero: "",
          cns: "",
          naturalidade: "",
        }));
        this.participantes.splice(index + 1, 0, ...novos);
      } catch (error) {
        participante.plan_id = "";
        this.$swal.fire({
          position: "center",
          type: "error",
          title: "Erro",
          text: "Não foi possível carregar os planos do plano familiar.",
          showConfirmButton: true,
        });
      } finally {
        this.isLoading = false;
      }
    },

    updateTotal_Subtotal_Adesao() {
      let total = 0;
      let subtotal = 0;
      let adesao = 0;
      
      this.shoppingCar.plans.map( plan => {
          total += (plan.price * plan.qtd);
          adesao += (plan.setup_fee * plan.qtd)
      })
      subtotal = total + adesao;
      
      this.shoppingCar = {
        plans: this.shoppingCar.plans,
        total,
        subtotal,
        adesao
      }
    },

    validaTitular() {
      let self = this;
      const validate = isEmpty(self.titular);
      const nameValidate = isName(self.titular.name);
      const emailValidate = isEmail(self.titular.email);
      const cpfValidate = cpf.isValid(self.titular.cpf);
      const birthValidate = isBirthday(self.titular.birth_date);
      const nomeMaeValidate = isName(self.titular.nome_mae);

      if (validate && nameValidate && emailValidate && cpfValidate && birthValidate && nomeMaeValidate) {
        self.cadastrarDependenteComTitular(true);
      } else {
        let text = "";
        if (!validate) text = 'Todos os dados do titular devem ser preenchidos!';
        else if (!nameValidate || !nomeMaeValidate) text = 'Os campos Nome ou Nome da Mãe não devem conter números ou caracteres especiais!';
        else if (!emailValidate) text = 'Por favor, insira um email válido!';
        else if (!cpfValidate) text = 'Por favor, insira um CPF válido!';
        else if (!birthValidate) text = 'Por favor, insira uma data de nascimento válida!';
        
        this.$swal.fire({
          position: "center",
          type: "warning",
          title: "Aviso",
          text,
          showConfirmButton: true,
        });
      }
    },

    validaCupom() {
      if(this.cupom != ""){
        let array_planos = [];
        this.planos.map((pl) => {
          array_planos.push(pl.id);
        })
        let obj = {
          cupons: [this.cupom],
          plans: array_planos
        }
        let cupons = [this.cupom];
        axios.post('validar_cupons', obj)
        .then(response => {
          let resposta = response.data;
          this.tem_cupom = true;
          if(resposta.cupons[0].valido) {
            this.$swal.fire({
              position: "center",
              type: "success",
              title: "Cupom Válido",
              text: "O cupom será aplicado na mensalidade do primeiro mês",
              showConfirmButton: true,
            });
            this.valor_cupom = resposta.valor;
            this.cupom_valido = this.cupom;
            this.cupom_class = 'success-class'
          } else {
            this.$swal.fire({
              position: "center",
              type: "error",
              title: "Atenção",
              text: resposta.mensagem ? resposta.mensagem : 'Cupom Inválido',
              showConfirmButton: true,
            });
            this.cupom = '';
            this.cupom_valido = false,
            this.valor_cupom = 0;
            this.cupom_class = 'error-class'
          }
        }).catch(() => {
        })
      }
    },

    deletarOportunidade(){
      let self = this;
      self.$swal.fire({
        position: "center",
        type: "warning",
        title: "Atenção",
        text: 'Deseja mesmo deletar essa oportunidade?',
        showCancelButton: true,
        showCancelButton: true,
        confirmButtonText: `Excluir`,
        cancelButtonText: `Cancelar`,
      }).then((result) => {
        if (!result.dismiss) {
          this.isLoading = true;
          axios.delete("deletar_oportunidade/" + self.$route.params.id)
          .then((response) => {
            this.isLoading = false;
            this.$swal.fire({
              position: "center",
              type: "success",
              title: "Oportunidade deletada com sucesso!",
              showConfirmButton: false,
            });
            self.$router.replace({path: '/corretor/oportunidades/'})
          })
          .catch((error) => {
            this.isLoading = false;
            tratamento_requisicao(error, this);
          });
        }
      })
    },

    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },

    isDate18orMoreYearsOld(day, month, year) {
      return new Date(year+18, month-1, day) <= new Date();
    },

    editUser() {
      this.isLoading = true;
      let info_assinante = {
        birth_date: this.assinante.birth_date,
        city: this.assinante.city,
        cns: this.assinante.cns,
        complement: this.assinante.complement,
        corretores_id: this.assinante.corretores_id,
        country: this.assinante.country,
        cpf: this.assinante.cpf.replace(/\D/g, ""),
        created_at: this.assinante.created_at,
        district: this.assinante.district,
        email: this.assinante.email,
        id: this.assinante.id,
        last_name: this.assinante.last_name,
        name: this.assinante.name,
        rg: this.assinante.rg,
        state: this.assinante.state,
        street: this.assinante.street,
        street_number: this.assinante.street_number,
        telefone: this.assinante.telefone,
        updated_at: this.assinante.updated_at,
        user_id: this.assinante.user_id,
        uuid: this.assinante.uuid,
        zip_code: this.assinante.zip_code
      }

      const cpfValidate = cpf.isValid(info_assinante.cpf);
      const nameValidate = isName(info_assinante.name);
      const lastNameValidate = isName(info_assinante.last_name);
      const telValidate = info_assinante.telefone.length > 14;
      const validate = isEmpty(info_assinante);

      if (cpfValidate && nameValidate && lastNameValidate && validate && telValidate) {
        axios.all([
          axios.put(`update_user_por_corretor/${this.assinante.user_id}`, info_assinante),
          axios.put(`oportunidades_detalhes/phone/${this.assinante.id}`, {
            area_code: info_assinante.telefone.split(' ')[0].substring(1, 3),
            number: info_assinante.telefone.split(' ')[1].replace('-', ''),
            country_code: 55,
            user_id: info_assinante.user_id
          })
        ]).then(axios.spread((res, phoneRes) => {
          this.$swal.fire({
            position: "center",
            type: "success",
            title: "Alterado com sucesso!",
            showConfirmButton: true,
          });
          this.isLoading = false;
        })).catch((e) => {
          this.$swal.fire({
            position: "center",
            type: "error",
            title: "Erro ao salvar",
            text: e.response.data.message,
            showConfirmButton: true,
          });
          this.isLoading = false;
        });
      } else {
        let text = "";
        if (!validate) text = 'Por favor, todos os campos devem estar preenchidos.'
        else if (!telValidate) text = 'Telefone inválido!'
        else if(!cpfValidate) text = 'Por favor, insira um CPF válido.'
        else if (!nameValidate || !lastNameValidate) text = 'Nome e Sobrenome não devem conter números ou caracteres especiais!'
       
        this.$swal.fire({
          position: "center",
          type: "warning",
          title: "Aviso",
          text,
          showConfirmButton: true
        });
        this.isLoading = false;
      }
    },

    async cadastrarDependenteComTitular(pegarTitular) {
      this.isLoading = true;
      let infos_participantes = [];
      let self = this;
      let isEmptyValidate = true;
      let cpfValidate = true;
      let emailValidate = true;
      let nameValidate = true;
      let nomeMaeValidate = true;
      let maiorIdade = false;

      self.participantes.map((particip) => {
        let info_particip = {
          birth_date: particip.birth_date,
          cns: particip.cns,
          cpf: particip.cpf.replace(/\D/g, ""),
          email: particip.email,
          id: particip.id,
          name: particip.name,
          naturalidade: particip.naturalidade,
          nome_mae: particip.nome_mae,
          estado_civil: particip.estado_civil,
          genero: particip.genero,
          parentesco: particip.parentesco,
          plan_id: particip.plan_id,
          plano_base: particip.plano_base || null,
          rg: particip.rg,
          subscriber_id: particip.subscriber_id
        }

        if (isEmptyValidate && cpfValidate && emailValidate && nameValidate && nomeMaeValidate) {
          for (const info in info_particip) {
            //validacao de campos vazios
            isEmptyValidate = isEmpty(info_particip);
            //validacao cpf
            if (info === 'cpf') cpfValidate = cpf.isValid(info_particip[info]);
            //validacao email
            if (info === 'email') emailValidate = validate(info_particip[info]);
            //validacao nomes
            if (info === 'name') nameValidate = isName(info_particip[info]);
            if (info === 'nome_mae') nomeMaeValidate = isName(info_particip[info]);
          }
        }

        infos_participantes.push(info_particip);
      });

      let titularEnviar = null;
      if(pegarTitular){
        titularEnviar = {
          ...self.titular,
          cpf: self.titular.cpf.replace(/\D/g, ""),
        };
     
        //validacao maior de idade
        if (titularEnviar.birth_date) {
          let ano = parseInt(titularEnviar.birth_date.split("/")[2]);
          let mes = parseInt(titularEnviar.birth_date.split("/")[1]);
          let dia = parseInt(titularEnviar.birth_date.split("/")[0]);
          if (this.isDate18orMoreYearsOld(dia,mes,ano)) maiorIdade = true;
          titularEnviar.birth_date = padronizaDataUS(self.titular.birth_date);
        }
      }

      const finalValidate = titularEnviar === null 
        ? isEmptyValidate && cpfValidate && emailValidate && nameValidate && nomeMaeValidate
        : isEmptyValidate && cpfValidate && emailValidate && nameValidate && nomeMaeValidate && maiorIdade;

      if (finalValidate) {
        await this.updateShoppingCar();
        //timeout necessário para aguardar a atualizacao do carrinho
        setTimeout(() => {
          axios
            .post("register_dependents_por_corretor", {
              dependents: infos_participantes,
              titular: titularEnviar,
              ...{ subscriber_id: self.$route.params.id },
              carrinho: this.carrinho,
            })
            .then((res) => {
              self.$swal.fire({
                position: "center",
                type: "success",
                title: "Dependentes cadastrados com sucesso!",
                showConfirmButton: true,
              });
              if (res.data.titular) {
                this.titular = res.data.titular;
                this.titular.cpf = numberToCpf(this.titular.cpf);
                this.titular.birth_date = toDate(this.titular.birth_date);
              } else {
                this.titular = {
                  name: "",
                  birth_date: "",
                  cpf: "",
                  rg: "",
                  email: "",
                  parentesco: "",
                  nome_mae: "",
                  genero: "",
                  estado_civil: ""
                }
              }
              this.participantes = res.data.data;
              this.plansList = [];
              this.participantes.map(particip => {
                particip.birth_date = toDate(particip.birth_date);
                particip.plan_id = parseInt(particip.plan_id);
                this.plansList.push(particip.plan_id);
              });
              this.qtdParticipantes = res.data.data.length;
              this.$bvModal.hide('modalTitular');
              this.isLoading = false;
            })
            .catch((e) => {
              self.$swal.fire({
                position: "center",
                type: "error",
                title: "Erro ao salvar",
                text: e.message,
                showConfirmButton: true,
              });
              // this.$bvModal.hide('modalTitular');
              this.isLoading = false;
            });
        }, 2000);

          // axios.get(`oportunidades_detalhes/${this.$route.params.id}`)
          //   .then((res) => {
          //     let assinante = {
          //       ...res.data.assinante,
          //       ...res.data.usuario,
          //       ...{ telefone: res.data.telefone.area_code + res.data.telefone.number },
          //     };
          //     this.assinante = assinante;
          //     if (res.data.dependentes.length > 0) {
          //       this.participantes = res.data.dependentes;
          //       this.participantes.map((part) => {
          //         part.birth_date = padronizaData(part.birth_date);
          //       })
          //     }
          //     for(let i=this.participantes.length; i<this.planos.length; i++){
          //       let particip = {
          //         plan_id: this.planosEscolher[i].id,
          //         name: "",
          //         birth_date: "",
          //         cpf: "",
          //         rg: "",
          //         email: "",
          //         parentesco: "",
          //         nome_mae: "",
          //         cns: "",
          //         naturalidade: "",
          //       }
          //       this.participantes[i] = particip
          //     }
          //     this.isLoading = false;
          //   })
          //   .catch((err) => {
          //     this.$swal.fire({
          //       position: "center",
          //       type: "error",
          //       title: "Erro",
          //       text: "Erro ao buscar oportunidade.",
          //       showConfirmButton: true,
          //     })
          //     this.isLoading = false;
          //   });
      } else {
        let  text = '';
        if (!isEmptyValidate) text = 'Campo obrigatório não preenchido';
        else if (!nameValidate || !nomeMaeValidate) text = 'Por favor, nomes não devem conter números ou caracteres especiais';
        else if (!cpfValidate) text = 'Por favor, insira um CPF válido';
        else if (!emailValidate) text = 'Por favor, insira um email válido';
        else if (!maiorIdade) text = 'O titular não pode ter menos de 18 anos';
        
        this.$swal.fire({
          position: "center",
          type: "warning",
          title: "Aviso",
          text,
          showConfirmButton: true,
        });
        this.isLoading = false;
      }
    },
    
    saveDependents() {
      if (this.participantes.length > 0) {
        let temMaior = false;
        let temData = null;
        const dateValidate = [];
        this.participantes.map((element, key) => {
          dateValidate.push(isBirthday(element.birth_date));
          if(element.birth_date !== '') {
            temData = true;
            var ano = parseInt(element.birth_date.split("/")[2]);
            var mes = parseInt(element.birth_date.split("/")[1]);
            var dia = parseInt(element.birth_date.split("/")[0]);
            if (this.isDate18orMoreYearsOld(dia,mes,ano)) temMaior = true;
          } else {
            temData = false;
          }
        });

        if(temData && dateValidate.every(date => date === true)) {
          if (!temMaior) {
            this.$bvModal.show('modalTitular');
          } else {
            this.cadastrarDependenteComTitular(false);
          }
        } else {
          this.$swal.fire({
            position: "center",
            type: "error",
            title: "Erro ao salvar",
            text: "Por favor, verifique a data de nascimento e insira um valor válido.",
            showConfirmButton: true,
          });
        }
      } else {
        this.$swal.fire({
          position: "center",
          type: "error",
          title: "Erro ao salvar",
          text: "Nenhum participante foi adicionado anteriormente.",
          showConfirmButton: true,
        });
      }
    },

    async updateShoppingCar() {
      if(this.participantes.length !== 0) {
        const olderPlans = this.plansList;
        this.plansList = [];
        this.participantes.map((part) => this.plansList.push(parseInt(part.plan_id)));
        const plansListCopy = Object.assign([], this.plansList);
        const plansListToCompare = plansListCopy.splice(0, this.qtdParticipantes);

        if (olderPlans !== plansListToCompare) {
          //Atualizando um participante
          this.plansCorretorId.map( planCorretorId => {
            const qtd = plansListToCompare.filter(id => id === planCorretorId).length;
            if (qtd > 0) {
              const planIndex = this.shoppingCar.plans.findIndex(plan => plan.id === planCorretorId);
              if (planIndex !== -1) {
                this.shoppingCar.plans[planIndex].qtd = qtd;
                this.updateTotal_Subtotal_Adesao();
              } else {
                axios
                  .get(`detalhes/plano/${planCorretorId}`)
                  .then((res) => res.data)
                  .then((response) => {
                    this.shoppingCar.plans.push({...response.plano, qtd});
                    this.updateTotal_Subtotal_Adesao();
                  })
                  .catch(() => {
                    this.isLoading = false;
                    this.$swal.fire({
                      position: "center",
                      type: "error",
                      title: "Erro",
                      text: "Erro ao buscar os detalhes dos planos.",
                      showConfirmButton: true,
                    })
                  })
              }
            } else {
              const olderPlanId = olderPlans.find( olderPlanId => olderPlanId === planCorretorId);
              const olderPlanIndex = this.shoppingCar.plans.findIndex( plan => plan.id === olderPlanId);
              if (olderPlanIndex !== -1) this.shoppingCar.plans.splice(olderPlanIndex, 1);
            }
          })
        } 
        
        if (this.participantes.length > this.qtdParticipantes) {
          //Adicionando um participante
          const qtdParticipantesAdicionados = this.participantes.length - this.qtdParticipantes;
          for (let i = 1; i <= qtdParticipantesAdicionados; i++) {
            try{
              const index = this.shoppingCar.plans.findIndex(plan => plan.id === this.plansList[this.plansList.length - i]);
              if (index !== -1) {
                this.shoppingCar.plans[index].qtd += 1;
                this.updateTotal_Subtotal_Adesao();
              } else {
                await axios
                  .get(`detalhes/plano/${this.plansList[this.plansList.length - i]}`)
                  .then((res) => res.data)
                  .then((response) => {
                    this.shoppingCar.plans.push(response.plano);
                    this.updateTotal_Subtotal_Adesao();
                  })
              }
            } catch (e) {
              this.isLoading = false;
              this.$swal.fire({
                position: "center",
                type: "error",
                title: "Erro",
                text: "Erro ao buscar os detalhes dos planos.",
                showConfirmButton: true,
              })
            }
          }
        }
      }
    },

    getAddress(code) {
      if (code.length > 8) {
        this.isLoading = true;
          fetch(`https://viacep.com.br/ws/${code}/json/`)
            .then((res) => res.json())
            .then((res) => {
              if (res.erro) {
                this.$swal.fire({
                  position: "center",
                  type: "error",
                  title: "Erro",
                  text: 'Por favor, insira um CEP válido.',
                  showConfirmButton: true,
                });

                this.assinante.zip_code = '';
                this.assinante.city = '';
                this.assinante.district = '';
                this.assinante.state = '';
                this.assinante.street = '';
                this.assinante.street_number = '';
              } else {

                this.assinante.city = res.localidade;
                this.assinante.country = "BRA";
                this.assinante.district = res.bairro;
                this.assinante.state = res.uf;
                this.assinante.street = res.logradouro;

                let abrangente = false;
                this.abrangencia.map( cityAbrangencia => {
                  if (this.assinante.city === cityAbrangencia.nome) {
                    abrangente = true;
                  }
                })

                if (!abrangente) {
                  this.$swal.fire({
                    position: "center",
                    type: "error",
                    title: "Erro ao encontrar a cidade",
                    text: "Esta cidade não faz parte da abrangência do plano.",
                    showConfirmButton: true,
                  });

                  this.assinante.zip_code = '';
                  this.assinante.city = '';
                  this.assinante.district = '';
                  this.assinante.state = '';
                  this.assinante.street = '';
                  this.assinante.street_number = '';
                }
              };
            });
        this.isLoading = false;
      } else {
        if (code.length > 0) {
          this.$swal.fire({
            position: "center",
            type: "warning",
            title: "Aviso",
            text: "Digite um CEP válido.",
            showConfirmButton: true,
          });
        }
        this.assinante.zip_code = '';
        this.assinante.city = '';
        this.assinante.district = '';
        this.assinante.state = '';
        this.assinante.street = '';
        this.assinante.street_number = '';
      }
    },
    addParticipante() {
      this.participantes.push({
        plan_id: "",
        plano_base: null,
        name: "",
        birth_date: "",
        cpf: "",
        rg: "",
        email: "",
        parentesco: "",
        nome_mae: "",
        estado_civil: "",
        genero: "",
        cns: "",
        naturalidade: "",
      });
    },
    deletarParticipante(i) {
      this.isLoading = true;
      if (this.participantes.length > 1) {
        let dependente = this.participantes[i];
        if (dependente.id) {
          axios
            .delete(`dependentes/${dependente.id}`)
            .then( (res) => {
              this.participantes.splice(i, 1);
              this.qtdParticipantes = this.participantes.length;
              this.plansList.splice(i, 1);
              const index = this.shoppingCar.plans.findIndex(plan => plan.id === dependente.plan_id);
              if (this.shoppingCar.plans[index].qtd > 1) {
                this.shoppingCar.plans[index].qtd -= 1;
              } else {
                this.shoppingCar.plans.splice(index, 1);
              }
              this.updateTotal_Subtotal_Adesao();

              this.$swal.fire({
                position: "center",
                type: "success",
                title: "Sucesso",
                text: 'Participante deletado com sucesso.',
                showConfirmButton: true,
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.$swal.fire({
                position: "center",
                type: "error",
                title: "Erro",
                text: 'Participante não pôde ser deletado. Tente novamente mais tarde.',
                showConfirmButton: true
              });
              this.isLoading = false;
            });
        } else {
          this.participantes.splice(i, 1);
          this.isLoading = false;
        }
      } else {
        this.$swal.fire({
          position: "center",
          type: "error",
          title: "Erro",
          text: 'Participante não pôde ser deletado.',
          showConfirmButton: true
        });
        this.isLoading = false;
      }
    },
    async handleCheckout(){
      this.isLoading = true;
      let info_assinante = {
        birth_date: this.assinante.birth_date,
        city: this.assinante.city,
        cns: this.assinante.cns,
        complement: this.assinante.complement,
        corretores_id: this.assinante.corretores_id,
        country: this.assinante.country,
        cpf: this.assinante.cpf.replace(/\D/g, ""),
        created_at: this.assinante.created_at,
        district: this.assinante.district,
        email: this.assinante.email,
        id: this.assinante.id,
        last_name: this.assinante.last_name,
        name: this.assinante.name,
        rg: this.assinante.rg,
        state: this.assinante.state,
        street: this.assinante.street,
        street_number: this.assinante.street_number,
        telefone: this.assinante.telefone,
        updated_at: this.assinante.updated_at,
        user_id: this.assinante.user_id,
        uuid: this.assinante.uuid,
        zip_code: this.assinante.zip_code
      }

      const cpfValidate_user = cpf.isValid(info_assinante.cpf);
      const nameValidate_user = isName(info_assinante.name);
      const lastNameValidate_user = isName(info_assinante.last_name);
      const telValidate_user = info_assinante.telefone.length > 14;
      const validate_user = isEmpty(info_assinante);

      let validate_particip = true;
      let cpfValidate_particip = true;
      let emailValidate_particip = true;
      let nameValidate_particip = true;
      let nomeMaeValidate_particip = true;

      let infos_participantes = [];
      this.participantes.map((particip) => {
        let info_particip = {
          birth_date: particip.birth_date,
          cns: particip.cns,
          cpf: particip.cpf.replace(/\D/g, ""),
          email: particip.email,
          id: particip.id,
          name: particip.name,
          naturalidade: particip.naturalidade,
          nome_mae: particip.nome_mae,
          estado_civil: particip.estado_civil,
          genero: particip.genero,
          parentesco: particip.parentesco,
          plan_id: particip.plan_id,
          rg: particip.rg,
          subscriber_id: particip.subscriber_id
        }

        if (validate_particip && cpfValidate_particip && emailValidate_particip && nameValidate_particip && nomeMaeValidate_particip) {
          for (const info in info_particip) {
            //validacao de campos vazios
            validate_particip = isEmpty(info_particip);
            //validacao cpf
            if (info === 'cpf') cpfValidate_particip = cpf.isValid(info_particip[info]);
            //validacao email
            if (info === 'email') emailValidate_particip = validate(info_particip[info]);
            //validacao nomes
            if (info === 'name') nameValidate_particip = isName(info_particip[info]);
            if (info === 'nome_mae') nomeMaeValidate_particip = isName(info_particip[info]);
          }
        }

        infos_participantes.push(info_particip);
      });
      
      let validate_titular, nameValidate_titular, emailValidate_titular, cpfValidate_titular, birthValidate_titular, nomeMaeValidate_titular;
      let maiorIdade = false;
      let titularEnviar = null;
      let temTitular = false;
      if (this.participantes.length > 0) {
        let temMaior = false;
        let temData = null;
        const dateValidate = [];
        this.participantes.map( element => {
          dateValidate.push(isBirthday(element.birth_date));
          if(element.birth_date !== '') {
            temData = true;
            var ano = parseInt(element.birth_date.split("/")[2]);
            var mes = parseInt(element.birth_date.split("/")[1]);
            var dia = parseInt(element.birth_date.split("/")[0]);
            if (this.isDate18orMoreYearsOld(dia,mes,ano)) temMaior = true;
          } else {
            temData = false;
          }
        });

        if(temData && dateValidate.every(date => date === true)) {
          temTitular = !temMaior ? true : false;
        }
      }
      
      if (temTitular) {
        validate_titular = isEmpty(this.titular);
        nameValidate_titular = isName(this.titular.name);
        emailValidate_titular = isEmail(this.titular.email);
        cpfValidate_titular = cpf.isValid(this.titular.cpf);
        birthValidate_titular = isBirthday(this.titular.birth_date);
        nomeMaeValidate_titular = isName(this.titular.nome_mae);

        titularEnviar = {
          ...this.titular,
          cpf: this.titular.cpf.replace(/\D/g, ""),
        };
        
        //validacao maior de idade
        if (titularEnviar.birth_date) {
          let ano = parseInt(titularEnviar.birth_date.split("/")[2]);
          let mes = parseInt(titularEnviar.birth_date.split("/")[1]);
          let dia = parseInt(titularEnviar.birth_date.split("/")[0]);
          if (this.isDate18orMoreYearsOld(dia,mes,ano)) maiorIdade = true;
          titularEnviar.birth_date = padronizaDataUS(this.titular.birth_date);
        }
      }

      let info = {
        cupons: this.cupom_valido ? [this.cupom_valido]: null,
        billing_info: {
          credit_card: {
            holder_name: this.checkout.billing_info.credit_card.holder_name,
            number: (this.checkout.billing_info.credit_card.number).replace(/\D/g, ""),
            cvv: this.checkout.billing_info.credit_card.cvv,
            expiration_month: this.checkout.billing_info.credit_card.expiration_month,
            expiration_year: this.checkout.billing_info.credit_card.expiration_year,
            bandeira: this.getCardType,
            cpf: (this.checkout.billing_info.credit_card.cpf).replace(/\D/g, "")
          }
        }
      }

      const validate_card = isEmpty(info.billing_info.credit_card);
      const holderNameValidate_card = isName(info.billing_info.credit_card.holder_name);
      const cpfValidate_card = cpf.isValid(info.billing_info.credit_card.cpf);
      const cvvValidate_card = info.billing_info.credit_card.cvv.length === 3;
      const expDateValidate_card = isExpDate(`${info.billing_info.credit_card.expiration_month}/${info.billing_info.credit_card.expiration_year}`)
      const numberValidate_card = info.billing_info.credit_card.number.length === 16;
      
      const finalValidate = 
        temTitular
          ?
            cpfValidate_user && nameValidate_user && lastNameValidate_user &&
            telValidate_user && validate_user && validate_particip &&
            cpfValidate_particip && emailValidate_particip &&  nameValidate_particip &&
            nomeMaeValidate_particip && validate_card && holderNameValidate_card &&
            cpfValidate_card && cvvValidate_card && expDateValidate_card &&
            numberValidate_card && validate_titular && nameValidate_titular &&
            emailValidate_titular && cpfValidate_titular && birthValidate_titular &&
            nomeMaeValidate_titular && maiorIdade
          
          : cpfValidate_user && nameValidate_user && lastNameValidate_user &&
            telValidate_user && validate_user && validate_particip &&
            cpfValidate_particip && emailValidate_particip && nameValidate_particip &&
            nomeMaeValidate_particip && validate_card && holderNameValidate_card &&
            cpfValidate_card && cvvValidate_card && expDateValidate_card &&
            numberValidate_card;

      if (finalValidate) {
        await axios
        .put(`update_user_por_corretor/${this.assinante.user_id}`, info_assinante)
        .then(async(res) => {
          if(infos_participantes.length > 0){
            await this.updateShoppingCar();
            await axios
            .post("register_dependents_por_corretor", {
              dependents: infos_participantes,
              ...{ subscriber_id: this.$route.params.id },
              titular: titularEnviar,
              carrinho: this.carrinho,
            })
            .then(async(res) => {
              if (res.data.titular) {
                this.titular = res.data.titular;
                this.titular.cpf = numberToCpf(this.titular.cpf);
                this.titular.birth_date = toDate(this.titular.birth_date);
              } else {
                this.titular = {
                  name: "",
                  birth_date: "",
                  cpf: "",
                  rg: "",
                  email: "",
                  parentesco: "",
                  nome_mae: "",
                  genero: "",
                  estado_civil: ""
                }
              }
              this.participantes = res.data.data;
              this.plansList = [];
              this.participantes.map(particip => {
                particip.birth_date = toDate(particip.birth_date);
                particip.plan_id = parseInt(particip.plan_id);
                this.plansList.push(particip.plan_id);
              });
              await axios
                .post(`assinatura/checkout_corretor/${this.$route.params.id}`, info)
                .then((res) => {
                  this.$swal.fire({
                    position: "center",
                    type: "success",
                    title: "Pago com sucesso!",
                    showConfirmButton: true,
                  });
                  this.isLoading = false;
                  this.$router.replace(this.$route.query.redirect || "/corretor/dashboard");
                })
                .catch((e) => {
                  this.$swal.fire({
                    position: "center",
                    type: "error",
                    title: "Erro ao realizar pagamento",
                    text: e.response.data.message,
                    showConfirmButton: true,
                  });
                  this.isLoading = false;
                });
            })
            .catch((e) => {
              this.$swal.fire({
                position: "center",
                type: "error",
                title: "Erro ao salvar dependentes",
                text: e.response.data.message,
                showConfirmButton: true,
              });
              this.isLoading = false;
            });
          } else {
            this.$swal.fire({
              position: "center",
              type: "error",
              title: "Erro ao salvar dependentes!",
              text: "Verifique se você possui algum.",
              showConfirmButton: true,
            });
            this.isLoading = false;
          }
        })
        .catch((e) => {
          this.$swal.fire({
            position: "center",
            type: "error",
            title: "Erro ao salvar corretor",
            text: e.response.data.message,
            showConfirmButton: true,
          });
          this.isLoading = false;
        });
      } else {
        let text = "";
        if (!validate_user) text = "Por favor, todos os campos do contratante devem estar preenchidos."
        else if (!cpfValidate_user) text = "Por favor, insira um CPF válido para o contratante."
        else if (!lastNameValidate_user || !nameValidate_user) text = "Nome e Sobrenome do contratante não devem conter números ou caracteres especiais!"
        else if (!telValidate_user) text = "Telefone do contratante está inválido!"
        else if (!validate_particip) text = "Por favor, todos os campos dos participantes devem estar preenchidos."
        else if (!cpfValidate_particip) text = "Por favor, insira CPF válido para os participantes."
        else if (!emailValidate_particip) text = "Por favor, insira email válido para os participantes."
        else if (!nameValidate_particip || !nomeMaeValidate_particip) text = "Nome e Sobrenome dos participantes não devem conter números ou caracteres especiais!"
        else if (!validate_card) text = "Por favor, preencha todos os campos do cartão."
        else if (!holderNameValidate_card) text = "Por favor, nome presente no cartão não deve conter números ou caracteres especiais."
        else if (!cpfValidate_card) text = "Por favor, insira um CPF válido para o portador do cartão."
        else if (!numberValidate_card) text = "Por favor, insira um número do cartão válido."
        else if (!cvvValidate_card) text = "Por favor, insira um CVV válido."
        else if (!expDateValidate_card) text = "Por favor, insira uma data de expiração válida."
        else if (!validate_titular) text = 'Por favor, todos os campos do titular devem estar preenchidos.'
        else if (!nameValidate_titular || !nomeMaeValidate_titular) text = 'Por favor, o nome do titular e o nome da mãe do titular não devem conter números ou caracteres especiais'
        else if (!cpfValidate_titular) text = 'Por favor, insira um CPF válido para o titular'
        else if (!emailValidate_titular) text = 'Por favor, insira um email válido para o titular'
        else if (!birthValidate_titular) text = 'Por favor, insira uma data de nascimento válida para o titular'
        else if (!maiorIdade) text = 'O titular não pode ter menos de 18 anos'

        this.$swal.fire({
          position: "center",
          type: "warning",
          title: "Aviso",
          text,
          showConfirmButton: true,
        });

        const condition = cpfValidate_user && nameValidate_user && lastNameValidate_user &&
            telValidate_user && validate_user && validate_particip &&
            cpfValidate_particip && emailValidate_particip && nameValidate_particip &&
            nomeMaeValidate_particip && validate_card && holderNameValidate_card &&
            cpfValidate_card && cvvValidate_card && expDateValidate_card &&
            numberValidate_card;

        if (
          (!validate_titular || 
          !nameValidate_titular || 
          !nomeMaeValidate_titular || 
          !cpfValidate_titular || 
          !emailValidate_titular || 
          !birthValidate_titular || 
          !maiorIdade) && condition
        ) {
          this.$bvModal.show('modalTitular');
        }

        this.isLoading = false;
      }
    },
  },
  watch: {
    participantes: {
      deep: true,
      handler() {
        clearTimeout(this.cotacaoTimer);
        this.cotacaoTimer = setTimeout(() => this.atualizaCotacao(), 400);
      }
    },
    shoppingCar: function(shoppingCar) {
      this.carrinho = { plans: [] };
      shoppingCar.plans.map(plan => this.carrinho.plans.push({id: plan.id, qtd: plan.qtd}));
    }
  }
};
</script>

<style scoped>
.input-horario {
  width: 50px;
  border: blue;
}

#map {
  width: 100%;
}

.btn-color {
  background-color: #af104c;
}

.badge-item {
  color: #af104c;
}

.delete-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
}

.delete-item h4 {
  color: #af104c !important;
  cursor: pointer;
  text-decoration: underline;
  font-size: 1em;
}

.msg-success{
  border: solid 2px #34a007;
  color: #34a007;
  background-color: #35a00728;
  padding: 5px;
}

.msg-erro{
  border: solid 2px #c90c0c;
  color: #851313;
  background-color: #c90c0c2f;
  padding: 5px;
}


@media screen and (max-width: 767px) {
  .btnContainer{
    flex-flow: column;
  }

  .btnCustom{
    margin-bottom: 2rem;
  }
}

</style>